import { render, staticRenderFns } from "./Transcriptions.vue?vue&type=template&id=80c9502e&scoped=true"
import script from "./Transcriptions.vue?vue&type=script&lang=js"
export * from "./Transcriptions.vue?vue&type=script&lang=js"
import style0 from "./Transcriptions.vue?vue&type=style&index=0&id=80c9502e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c9502e",
  null
  
)

export default component.exports